import { RibbonBanner, type RibbonBannerProps } from '@ifixit/ui/components/ribbon-banner';
import initializeComponent from 'Shared/react-initialize';

function CarpenterRibbonBanner({
   page,
   ribbon,
}: {
   page: string;
   ribbon: RibbonBannerProps['ribbon'];
}) {
   return <RibbonBanner ribbon={ribbon} page={page} />;
}

initializeComponent('RibbonBanner', CarpenterRibbonBanner);
